import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import ActionBar from '../../components/ActionBar'
import Search from '../../components/Search'
import Table from '../../components/Table'
import Button from '../../components/shared/Button'
import { AddIcon } from '../../components/shared/Icons'
import Loader from '../../components/shared/Loader'
import Pagination from '../../components/shared/Pagination'
import useFetch from '../../hooks/useFetch'
import CaptionLayout from '../../layouts/CaptionLayout'
import Section from '../../layouts/Section'
import SectionBody from '../../layouts/SectionBody'
import { getAdmins } from '../../utils/Apis/admins'
import { cn } from '../../utils/helperFunctions'
import { withErrorHandling } from '../../utils/withErrorHandling'
import { columns } from './COLUMNS'

const AdminUsers = ({ className, ...props }) => {
  const { data, error, loading, refetch } = useFetch({
    fn: (search, currentPage) => getAdmins(search, currentPage),
  })
  const [search, setSearch] = React.useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const handleSearch = withErrorHandling(async (search) => {
    refetch(search)
  })
  useEffect(() => {
    document.title = 'Admins - Admin'
  }, [])
  useEffect(() => {
    if (search === '') refetch(search, currentPage)
  }, [search])
  useEffect(() => {
    refetch(search, currentPage)
  }, [currentPage])
  return (
    <div className={className} {...props}>
      <Section title={'Admins Accounts'} className={'lg:pb-2'}>
        <Search
          handleSearch={handleSearch}
          search={search}
          setSearch={setSearch}
          className={'top-0'}
        />
        <ActionBar className={'top-0'}>
          <></>
          <NavLink to={'/admin_users/new'}>
            <Button>
              <AddIcon className={'h-6 w-6'} />
              Add New Admin
            </Button>
          </NavLink>
        </ActionBar>
      </Section>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>Error</p>
      ) : (
        <SectionBody>
          <CaptionLayout results={data?.totalCount} caption={'Admin present'}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={data?.paginationResult?.numberOfPages}
            />
          </CaptionLayout>
          <div
            className={cn(
              'custom-scroll relative max-h-[45vh] w-full overflow-auto md:max-h-[60vh]',
              className,
            )}
            {...props}
          >
            <Table data={data?.data} columns={columns} />
            {/* Fade */}
            <div className="pointer-events-none sticky bottom-0 left-0 h-16 w-full bg-gradient-to-t from-background to-transparent" />
          </div>

          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pages={data?.paginationResult?.numberOfPages}
          />
        </SectionBody>
      )}
    </div>
  )
}

export default AdminUsers
